export default __webpack_public_path__ + "static/media/phone.35f631f8.svg";